import {
  Flex, Text, Button, Box
} from '@huspy/briks-web';
import { Image } from '@mantine/core';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import { imagesPath } from '@shared/css.const';
import { useTranslation } from 'react-i18next';

export const EmptyFieldsSlido = ({
  opened,
  save,
  close,
  isLoading,
}: {
  opened: boolean;
  isLoading: boolean;
  close: () => void;
  save: () => Promise<void>;
}) => {
  const { t } = useTranslation();

  const baseTranslation = 'opportunity.caseSubmission.documentSubmission.pendingForms.emptyFieldsModal';

  return (
    <BaseSlido
      opened={ opened }
      close={ () => {
        close();
      } }
      title={ (
        <Text size='3xl' px='4' py='8' weight='medium'>
          { t(`${baseTranslation}.header`) }
        </Text>
      ) }
      footer={ (
        <Flex w='100%' justify='flex-end' gap='2'>
          <Button
            variant='outline'
            data-test='skip-btn'
            disabled={ isLoading }
            loading={ isLoading }
            onClick={ async () => {
              await save();
            } }

          >
            {t(`${baseTranslation}.skipButton`)}
          </Button>
          <Button
            variant={ isLoading ? 'secondary' : 'primary' }
            data-test='proceed-btn'
            onClick={ close }
          >
            {t(`${baseTranslation}.saveButton`)}
          </Button>
        </Flex>
      ) }
    >
      <Flex
        direction='column'
        h='100%'
        justify='space-between'
      >
        <Flex bg='white' p='4' borderRadius='4' direction='column' my='2'>
          <Box w='100%' mb='2'>
            <Image src={ `${imagesPath}/missing-fields.png` } w='100%' />
          </Box>
          <Text size='3xl' my='2'>
            {t(`${baseTranslation}.title`)}
          </Text>
          <Text size='md' my='2' color='text-secondary'>
            {t(`${baseTranslation}.subtitle`)}
          </Text>
          <Text size='md' my='2' color='text-secondary'>
            {t(`${baseTranslation}.description`)}
          </Text>
        </Flex>
      </Flex>
    </BaseSlido>
  );
};
